import React from "react";

interface FeatureCardProps {
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
}) => {
  return (
    <div >
      <div className="flex flex-col items-start">
        <div className="bg-sage-100 p-2 rounded-lg mb-4 w-8 h-8">
          {/* Icon placeholder */}
        </div>
        <h3 className="text-2xl font-semibold font-noto mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

interface FeaturesProps {
  alignmentClasses: string;
}

const Features: React.FC<FeaturesProps> = ({ alignmentClasses }) => {
  const features = [
    {
      title: "Say Goodbye to Event Hunting",
      description:
        "Finding events shouldn't be stressful. With Soundness, you can explore a curated list of what's going on, all in one place.",
    },
    {
      title: "Make wellness accessible",
      description:
        "Wellbeing shouldn't be gatekept. With us find affordable and local events.",
    },
    {
      title: "Transform yourself",
      description:
        "Unlock your potential through experiences like sound healing, mindfulness, and more.",
    },
    {
      title: "Support independent practitioners",
      description:
        "Your wellness journey helps local practitioners grow and thrive.",
    },
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className={alignmentClasses}>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-12">
          <div className="lg:sticky lg:top-0 lg:h-full lg:flex lg:items-center">
            <div className="max-w-2xl mb-12 lg:mb-0">
              <h2 className="text-4xl font-noto mb-4">
                Community
                <br />
                is everything
              </h2>
            </div>
          </div>
          
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
              {features.map((feature, index) => (
                <FeatureCard
                  key={index}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
